import script from "./StudentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentModal.vue?vue&type=script&setup=true&lang=js"

import "./StudentModal.vue?vue&type=style&index=0&id=c8b52452&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b52452"]])

export default __exports__